import React, { FC } from 'react';

import { FileTypeSettings } from 'src/components/property-settings/sections/file-type-settings/FileTypeSettings';

import { useConfiguration } from '../../../providers/configurationProvider/ConfigurationProvider';
import { SiteScannerUiToggles } from '../../../services/LocalTogglesService';
import { usePropertySettings } from '../context';

import { useSetProperty } from './utils/useSetProperty';

export const FileTypeSectionModule: FC = () => {
	const { getToggle } = useConfiguration();
	const {
		state: { draft }
	} = usePropertySettings();
	const setProperty = useSetProperty();

	if (!getToggle(SiteScannerUiToggles.ENABLE_CRAWL_FILE_TYPES_OPTION)) {
		return null;
	}
	if (!draft) {
		return null;
	}
	return <FileTypeSettings property={draft} setProperty={setProperty} />;
};
